import { Box } from "@mui/material";

import { PageHeader } from "../../components/v3";
import { AddEditBulkWorkForm } from "../../components/worker";
import { PageLayout } from "../../layouts/PageLayout";

export const AddEditBulkWork = () => {
  return (
    <PageLayout>
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader title={"Add Overtime"} />
      </Box>

      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        <AddEditBulkWorkForm />
      </Box>
    </PageLayout>
  );
};
